import { css } from 'styled-components';
import {
  BASE_FONT_FAMILY,
  FONT_SIZES,
  FONT_WEIGHTS,
  PALETTE,
  BASE_FONT_COLOR,
} from '~/assets/styles/base';

const defaultStyle = css`
  html {
    font-size: ${FONT_SIZES.base};
    font-family: ${BASE_FONT_FAMILY};
    font-weight: ${FONT_WEIGHTS.base};
    color: ${BASE_FONT_COLOR};
    min-width: 1090px;
  }
  body {
    *,
    *::before,
    *::after {
      box-sizing: border-box;
    }
    height: inherit;
    background: ${PALETTE.bg.main};
    font-family: inherit !important;
    font-size: ${FONT_SIZES.bodyDefault};

    & > div.goog-tooltip {
      border: solid 1px #bdbdbd;
      border-radius: 2px;
      background-color: white;
      position: absolute;
      box-shadow: 0px 2px 2px 0px rgba(204, 204, 204, 0.6);
      font-size: 12px;
      padding: 0px;
      -moz-box-shadow: 0px 2px 2px 0px rgba(204, 204, 204, 0.6);
      -webkit-box-shadow: 0px 2px 2px 0px rgba(204, 204, 204, 0.6);
      z-index: 10000;
      margin: 0px auto;
      max-width: 960px;
      & > div {
        border: none !important;
        word-break: break-all;
      }
    }
  }

  button {
    appearance: none;
    background: none;
    border: none;
    outline: none;
    padding: 0;
  }

  input[type='text'] {
    appearance: none;
    background: none;
    border: none;
    outline: none;
    padding: 0;
  }
`;
export default defaultStyle;
